function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React from 'react';
import { useSelector } from 'react-redux';
import { FormattedMessage } from 'react-intl';
import useStyles from 'isomorphic-style-loader/useStyles';
import { useAction, useProgressSuccess } from 'hooks';
import Modal from 'components/Modal';
import App from 'modules/App';
import { REMOVE_PATIENT_MODAL } from '../../constants';
import * as selectors from '../../selectors';
import messages from '../../messages';
import styles from '../ModalCommon.pcss';
import Actions from './Actions';
import Person from './Person';
const RemovePatientModal = ()=>{
    const openModalId = useSelector(App.selectors.modal);
    const isInProgress = useSelector(selectors.isRemovePatientInProgress);
    const hasErrors = useSelector(selectors.hasRemovePatientErrors);
    const onCloseModal = useAction(App.actions.closeModal);
    useProgressSuccess(isInProgress, hasErrors, onCloseModal);
    useStyles(styles);
    return /*#__PURE__*/ _jsxs(Modal, {
        modalId: REMOVE_PATIENT_MODAL,
        openModalId: openModalId,
        styleModifier: "md",
        headerMessage: messages.headers.removePatient,
        isInProgress: isInProgress,
        onClose: onCloseModal,
        children: [
            /*#__PURE__*/ _jsxs("div", {
                className: styles.container,
                children: [
                    /*#__PURE__*/ _jsx(Person, {}),
                    /*#__PURE__*/ _jsx(FormattedMessage, _object_spread({}, messages.infos.areYouSureToRemovePatient))
                ]
            }),
            /*#__PURE__*/ _jsx(Actions, {})
        ]
    });
};
export default RemovePatientModal;
